module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-4th-cf6ceddf62a024bc8ff30a01904b6403.png";